import React, { memo, useState } from 'react';
import { ColorTokens, FontFamilyTokens, FontSizeTokens, SizeTypeTokens, DividerSizeTokens, IconSizeTokens, IconTokens, } from '@voltmoney/schema';
import { Icon } from '../icon/Icon';
import Typography from '../typography/Typography';
import { Dimensions, Platform, Pressable, View, } from 'react-native';
import Divider from '../divider/Divider';
/**
 * Primary UI component for user interaction
 */
const AccordionDefault = ({ id, title, description, icon, rightIcon, mainScreen, hideDivider = false, faqDownArrowIcon = false }) => {
    const [isActive, setIsActive] = useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement(View, { style: {
                width: Platform.OS !== 'web'
                    ? Dimensions.get('screen').width - 32
                    : '100%',
            } },
            React.createElement(Pressable, { nativeID: id, onPress: () => setIsActive(!isActive) },
                React.createElement(View, { style: {
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                    } },
                    React.createElement(View, { style: {
                            width: '95%',
                        } },
                        React.createElement(Typography, { label: title, fontFamily: FontFamilyTokens.Inter, fontWeight: '600', fontSize: FontSizeTokens.SM, color: ColorTokens.Grey_Night, lineHeight: 20 })),
                    React.createElement(View, { style: {
                            flex: 1,
                            alignItems: rightIcon
                                ? 'flex-start'
                                : 'flex-end',
                            justifyContent: rightIcon
                                ? 'flex-start'
                                : 'flex-end',
                            width: '5%',
                        } }, (!faqDownArrowIcon && !isActive) ? (React.createElement(Icon, { name: icon, size: IconSizeTokens.SM, color: ColorTokens.Grey_Night })) : isActive ? (React.createElement(Icon, { name: IconTokens.UpsideArrow, size: IconSizeTokens.SM, color: ColorTokens.Grey_Night })) : (React.createElement(Icon, { name: icon, size: IconSizeTokens.SM, color: ColorTokens.Grey_Night }))))),
            isActive ? (React.createElement(View, { style: {
                    paddingTop: 10
                } },
                React.createElement(Typography, { label: description, fontFamily: FontFamilyTokens.Inter, fontWeight: '400', fontSize: FontSizeTokens.XS, color: ColorTokens.Grey_Charcoal, lineHeight: 20 }))) : (React.createElement(React.Fragment, null)),
            !hideDivider ?
                React.createElement(Divider, { size: DividerSizeTokens.SM, margin: { vertical: SizeTypeTokens.XL }, color: ColorTokens.Grey_Milk_1 }) : React.createElement(View, { style: { height: 16 } }))));
};
export default memo(AccordionDefault);
export { AccordionDefault };
